// skillsData.js

export const skillsOthers = [
  {
    name: "Cypress",
    logo: "https://asset.brandfetch.io/idIq_kF0rb/idv3zwmSiY.jpeg",
  },
  {
    name: "Jest",
    logo: "https://ih1.redbubble.net/image.267642084.7827/st,small,507x507-pad,600x600,f8f8f8.u1.jpg",
  },
  {
    name: "Github",
    logo: "https://avatars1.githubusercontent.com/u/9919?v=4",
  },
  {
    name: "Webpack",
    logo: "https://miro.medium.com/v2/resize:fit:800/1*nhakXc4nb7IDA0wh5Kx2Kg.jpeg",
  },
  {
    name: "Co-pilot",
    logo: "https://1000logos.net/wp-content/uploads/2023/11/Copilot-Logo.png",
  },
  {
    name: "SonarQube",
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXm8pbhp4uB42rZ8tKlxmmd1Ajpxs8PQMHMg&s",
  },
];

export const skillsFrontend = [
  {
    name: "TypeScript",
    logo: "https://raw.githubusercontent.com/anupam-coder/newPortfolio/main/src/assets/img/skills/ts.png",
  },
  {
    name: "HTML",
    logo: "https://raw.githubusercontent.com/anupam-coder/newPortfolio/main/src/assets/img/skills/html.png",
  },
  {
    name: "CSS",
    logo: "https://raw.githubusercontent.com/anupam-coder/newPortfolio/main/src/assets/img/skills/css.png",
  },
  {
    name: "JavaScript",
    logo: "https://raw.githubusercontent.com/anupam-coder/newPortfolio/main/src/assets/img/skills/js.png",
  },
  {
    name: "React",
    logo: "https://raw.githubusercontent.com/anupam-coder/newPortfolio/main/src/assets/img/skills/react.png",
  },
  {
    name: "Redux",
    logo: "https://raw.githubusercontent.com/anupam-coder/newPortfolio/main/src/assets/img/skills/redux.png",
  },
];

export const skillsBackend = [
  {
    name: "NodeJS",
    logo: "https://raw.githubusercontent.com/anupam-coder/newPortfolio/main/src/assets/img/skills/node.png",
  },
  {
    name: "Java",
    logo: "https://raw.githubusercontent.com/anupam-coder/newPortfolio/main/src/assets/img/skills/java.png",
  },
  {
    name: "PostgreSQL",
    logo: "https://w7.pngwing.com/pngs/448/730/png-transparent-postgresql-plain-logo-icon.png",
  },
  {
    name: "SQL",
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_lTeBk0QdOhzcE4vM82jU6DESzpm27PmiGA&s",
  },
  {
    name: "Express",
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnDneBGnQL7E9hZDwztRO1GfQcCj1FqRrhBw&s",
  },
  {
    name: "MongoDB",
    logo: "https://pbs.twimg.com/profile_images/1452637606559326217/GFz_P-5e_400x400.png",
  },
  {
    name: "Springboot",
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8i4zPog-0j0JR_yZglxPhTPZXxN2iMTQ3Dw&s",
  },
];
